import React from 'react';
import PropTypes from 'prop-types';
import MarkdownRenderer from '../MarkdownRenderer/components/MarkdownRenderer';
import { useLocaleContext, useThemeContext } from '../../contexts';
import { getLocaleOrAvailable } from '../../utils/localeUtils';
import SignInButton from './SignInButton';

const CustomContainer = ({ components }) => {
  const locale = useLocaleContext();
  const [theme] = useThemeContext();
  return (
    <>
      {components.map(component => {
        const localeData = getLocaleOrAvailable(locale, component.value);
        switch (component.type) {
          case 'markdown':
            return (
              <MarkdownRenderer
                key={component.componentId}
                locale={localeData.locale}
                theme={component.theme ? component.theme : theme}
                padding={component.padding ? component.padding : true}
                markdown={localeData.markdown}
              />
            );

          case 'signInButton':
            return (
              <SignInButton
                key={component.componentId}
                idp={component.value.idp}
                primary={component.value.primary}
                localeData={localeData}
              />
            );
        }
      })}
    </>
  );
};

CustomContainer.propTypes = {
  components: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        type: PropTypes.oneOf(['markdown']).isRequired,
        componentId: PropTypes.string.isRequired,
        value: PropTypes.shape({
          locales: PropTypes.arrayOf(
            PropTypes.shape({
              locale: PropTypes.string.isRequired,
              markdown: PropTypes.string.isRequired,
            }).isRequired
          ).isRequired,
        }).isRequired,
        theme: PropTypes.string,
        padding: PropTypes.bool,
      }),
      PropTypes.shape({
        type: PropTypes.oneOf(['signInButton']).isRequired,
        componentId: PropTypes.string.isRequired,
        value: PropTypes.shape({
          idp: PropTypes.string.isRequired,
          primary: PropTypes.bool,
          locales: PropTypes.arrayOf(
            PropTypes.shape({
              locale: PropTypes.string.isRequired,
              label: PropTypes.string.isRequired,
            })
          ).isRequired,
        }).isRequired,
      }),
    ])
  ).isRequired,
};

export default CustomContainer;
